import React from 'react';

interface FunnelCardSkeletonProps {
  showProMode?: boolean;
}

export const FunnelCardSkeleton: React.FC<FunnelCardSkeletonProps> = ({
  showProMode = false
}) => {
  return (
    <div className="bg-white relative rounded-xl border shadow w-full animate-pulse">
      <div className="flex w-full border-b">
        {/* Header - Logo Section */}
        <div className="flex flex-col items-center justify-center p-4 border-r min-w-[120px]">
          <div className="w-16 h-16 bg-gray-200 rounded-lg mb-2"></div>
          <div className="w-20 h-3 bg-gray-200 rounded"></div>
        </div>

        {/* Body Section */}
        <div className="flex flex-col grow border-r">
          <div className="flex gap-4 items-center p-4 grow">
            <div className="w-full">
              <div className="w-32 h-3 bg-gray-200 rounded mb-2"></div>
              <div className="w-48 h-5 bg-gray-200 rounded mb-2"></div>
              <div className="w-24 h-3 bg-gray-200 rounded"></div>
            </div>
            <div className="flex flex-col items-end justify-center gap-2 w-full">
              <div className="flex items-center gap-2 px-3 py-1.5 bg-gray-100 rounded-full">
                <div className="w-2 h-2 bg-gray-300 rounded-full"></div>
                <div className="w-12 h-4 bg-gray-200 rounded"></div>
                <div className="w-16 h-3 bg-gray-200 rounded"></div>
              </div>
            </div>
          </div>
          <div className="p-4">
            <div className="flex gap-2 items-center">
              <div className="w-4 h-4 bg-gray-200 rounded"></div>
              <div className="w-48 h-3 bg-gray-200 rounded"></div>
            </div>
          </div>
          {showProMode && (
            <div className="flex border-t">
              <div className="flex justify-evenly gap-4 border-r grow w-full p-3">
                <div className="flex flex-col items-center gap-1">
                  <div className="w-16 h-3 bg-gray-200 rounded"></div>
                  <div className="w-12 h-5 bg-gray-200 rounded"></div>
                </div>
                <div className="flex flex-col items-center gap-1">
                  <div className="w-16 h-3 bg-gray-200 rounded"></div>
                  <div className="w-12 h-5 bg-gray-200 rounded"></div>
                </div>
              </div>
              <div className="grow w-full flex justify-center items-center gap-2 p-3">
                <div className="w-4 h-4 bg-gray-200 rounded"></div>
                <div className="w-28 h-3 bg-gray-200 rounded"></div>
              </div>
            </div>
          )}
        </div>

        {/* Footer - Price Section */}
        <div className="flex flex-col items-center justify-center p-4 min-w-[180px]">
          <div className="w-12 h-3 bg-gray-200 rounded mb-2"></div>
          <div className="w-24 h-6 bg-gray-200 rounded mb-1"></div>
          <div className="w-16 h-3 bg-gray-200 rounded mb-3"></div>
          <div className="w-full h-10 bg-gray-200 rounded-lg"></div>
        </div>
      </div>
    </div>
  );
};

interface FunnelCardSkeletonListProps {
  count?: number;
  showProMode?: boolean;
}

export const FunnelCardSkeletonList: React.FC<FunnelCardSkeletonListProps> = ({
  count = 3,
  showProMode = false
}) => {
  return (
    <>
      {Array.from({ length: count }).map((_, index) => (
        <FunnelCardSkeleton key={index} showProMode={showProMode} />
      ))}
    </>
  );
};
